import Flickity from 'flickity';
import $ from 'jquery';

$(document).ready(function() {
  const $planTabs = $('.m-plan-tabs');

  if ($planTabs.length === 0) {
    return;
  }

  //// Manages the animation in the cylinder

  // Capture tab event
  $planTabs.on('tabs:change', (event, dataTab) => {
    event.stopPropagation();
    setCylinderHeights(dataTab);
  });

  // Get tab values and set cylinder heights
  function setCylinderHeights(activeTab) {
    const $cylinder = $planTabs.find('.e-cylinder-chart');
    const $activeTab = $planTabs.find(`.tab-content.${activeTab}`);

    // Cacl total
    const values = $activeTab.find('.e-definition .term:not(.term-total) dd span');

    var total = 0.0;
    for (var i = 0; i < values.length; i++) {
      total += parsePrice($(values[i]).text());
    }

    for (var i = 0; i < values.length; i++) {
      var percentage = parsePrice($(values[i]).text()) * 100 / total;
      $cylinder.find(`.liquid:eq(${i})`).height(`${percentage}%`);
    }
  }

  function parsePrice(value) {
    let parsedValue = parseFloat(value.replace(',','.'));
    if (isNaN(parsedValue)) {
      parsedValue = 0;
    }
    return parsedValue
  }

  setCylinderHeights($planTabs.find('.e-tabs .tabs ul li.active a').attr('data-tab'));

  //// Duplicate the tab1 and tab2 contents in order to show a carousel in mobile

  // Placeholders
  const $occasional1PricePlaceholder = $planTabs.find('.tab-1 .occasional-1 .occasional-price');
  const $occasional2FeaturesPlaceholder = $planTabs.find('.tab-1 .occasional-2 .occasional-features');
  const $occasional2PricePlaceholder = $planTabs.find('.tab-1 .occasional-2 .occasional-price');

  // Contents
  const $occasional1Price = $planTabs.find('.tab-1 .m-pricing-box').clone();
  const $occasional2Features = $planTabs.find('.tab-2 .occasional-features').clone();
  const $occasional2Price = $planTabs.find('.tab-2 .m-pricing-box').clone();

  // Duplicate content (visible only for mobile, to do the tab slider)
  $occasional1PricePlaceholder.append($occasional1Price);
  $occasional2FeaturesPlaceholder.append($occasional2Features);
  $occasional2PricePlaceholder.append($occasional2Price);

  // Flickity carousel
  const slider = $planTabs.find('.tab-content.slider')[0];

  const flkty = new Flickity(slider, {
    cellSelector: '.slide',
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    prevNextButtons: false
  });
});



// WEBPACK FOOTER //
// ./app/ui/modules/plan-tabs/index.js